module.exports = __webpack_public_path__ + "static/media/watch.14f256e4.svg";